import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

import './styles/base.css';
import './styles/navbar.css';
import './styles/hero.css';
import './styles/about.css';
import './styles/services.css';
import './styles/team.css';
import './styles/contact.css';
import './styles/footer.css';
import './styles/enhance.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
